import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/php': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320 104.5C491.4 104.5 623.2 176.7 623.2 256S491.3 407.5 320 407.5C148.6 407.5 16.8 335.3 16.8 256S148.7 104.5 320 104.5M320 87.7C143.3 87.7 0 163 0 256S143.3 424.3 320 424.3 640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5C210.3 283 182.4 278.8 148.1 278.8L161.8 208.2C199.8 208.2 225.6 204.1 218.2 242.5zM97.4 350.3H134.1L142.8 305.5C183.9 305.5 209.4 308.5 233 286.4 259.1 262.4 265.9 219.7 247.3 198.3 237.6 187.1 222 181.6 200.8 181.6H130.1L97.4 350.3zM283.1 136.7H319.6L310.9 181.5C342.4 181.5 371.6 179.2 385.7 192.2 400.5 205.8 393.4 223.2 377.4 305.3H340.4C355.8 225.9 358.7 219.3 353.1 213.3 347.7 207.5 335.4 208.7 305.7 208.7L286.9 305.3H250.4L283.1 136.7zM505 242.5C497 283.6 468.3 278.8 434.9 278.8L448.6 208.2C486.8 208.2 512.4 204.1 505 242.5zM384.2 350.3H421L429.7 305.5C472.9 305.5 496.8 308 519.9 286.4 546 262.4 552.8 219.7 534.2 198.3 524.5 187.1 508.9 181.6 487.7 181.6H417L384.2 350.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/php.js
// module id = XwuV
// module chunks = 144